import api from '@/api/index.js'

const fare_group_fares = {
  state: {
    loading: false,
    updating: false,
    data: [],
    error: null
  },

  mutations: {
    SET_FARE_GROUP_FARES_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_FARE_GROUP_FARES_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_FARE_GROUP_FARES: (state, response) => {
      // Sort by discount_id, municipality_id (empty first), starts_at (desc), ends_at (desc, nulls first).
      const isEmpty = (value) => value === null || value === undefined || value === '';
      const toTime = (value) => new Date(value).getTime();
      const compareIds = (x, y) => String(x).localeCompare(String(y), undefined, {numeric: true});
      const compareEmptyFirst = (a, b, compare) => {
        if (isEmpty(a) && isEmpty(b)) return 0;
        if (isEmpty(a)) return -1;
        if (isEmpty(b)) return 1;
        return compare(a, b);
      };
      state.data = (response || []).slice().sort((a, b) =>
        compareEmptyFirst(a.discount_id, b.discount_id, compareIds) ||
        compareEmptyFirst(a.municipality_id, b.municipality_id, compareIds) ||
        compareEmptyFirst(a.starts_at, b.starts_at, (x, y) => toTime(y) - toTime(x)) ||
        compareEmptyFirst(a.ends_at, b.ends_at, (x, y) => toTime(y) - toTime(x))
      );
      state.loading = false;
    },
    SET_FARE_GROUP_FARES_UPDATED: (state, updated) => {
      state.data = state.data.filter(fare => {
        if (fare.id == updated.id) {
          fare.id = updated.id;
          fare.discount_id = updated.discount_id;
          fare.municipality_id = updated.municipality_id;
          fare.pricing.single = updated.pricing.single;
          fare.pricing.caps = updated.pricing.caps;
          fare.fare_group_id = updated.fare_group_id;
          fare.starts_at = updated.starts_at;
          fare.ends_at = updated.ends_at;
          fare.description = updated.description;
          fare.modified_by = updated.modified_by;
          fare.updated_at = updated.updated_at;
        }
        return fare
      });
      state.updating = false;
      state.loading = false;
    },
    SET_FARE_GROUP_FARES_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
    SET_FARE_GROUP_FARES_DELETED: (state, deleted) => {
      if (state.data) {
        state.data = state.data.filter(fare => fare.id != deleted.id);
      }
    },
  },

  actions: {
    LoadFareGroupFares({commit}, fareGroupID) {
      commit('SET_ERROR', null);
      commit('SET_FARE_GROUP_FARES_ERROR', null)
      commit('SET_FARE_GROUP_FARES_LOADING', true)
      commit('SET_FARE_GROUP_FARES', [])
      return api.get(`fare-groups/${fareGroupID}/fares`)
        .then((response) => {
          commit('SET_FARE_GROUP_FARES', response)
        })
        .catch((error) => {
          commit('SET_FARE_GROUP_FARES_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    CreateFare({commit}, payload) {
      commit('SET_FARE_GROUP_FARES_UPDATING', true);
      commit('SET_ERROR', null);
      commit('SET_FARE_GROUP_FARES_ERROR', null)
      return api.post(`fare-groups/${payload.fare_group_id}/fares`, payload)
        .then((response) => {
          commit('SET_FARE_GROUP_FARES_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_FARE_GROUP_FARES_ERROR', error);
          commit('SET_FARE_GROUP_FARES_UPDATING', false);
        })
    },
    DeleteFare({commit}, payload) {
      commit('SET_FARE_GROUP_FARES_UPDATING', true);
      commit('SET_ERROR', null);
      commit('SET_FARE_GROUP_FARES_ERROR', null)
      return api.delete(`fare-groups/${payload.fare_group_id}/fares/${payload.id}`)
        .then((response) => {
          commit('SET_FARE_GROUP_FARES_DELETED', payload);
          commit('SET_FARE_GROUP_FARES_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_FARE_GROUP_FARES_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText);
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_FARE_GROUP_FARES_UPDATING', false);
        })
    },
    UpdateFare({commit}, payload) {
      commit('SET_FARE_GROUP_FARES_UPDATING', true);
      commit('SET_ERROR', null);
      commit('SET_FARE_GROUP_FARES_ERROR', null)
      return api.put(`fare-groups/${payload.fare_group_id}/fares/${payload.id}`, payload)
        .then((response) => {
          commit('SET_FARE_GROUP_FARES_UPDATED', response.body);
        })
        .catch((error) => {
          commit('SET_FARE_GROUP_FARES_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText);
          commit('SET_FARE_GROUP_FARES_UPDATING', false);
        })
    },
  },
}

export default fare_group_fares
